import {
  EXCLUSIVE_LAYOUT_URLS, PAPER_CATEGORY_ID, SWITCH_AND_SAVE_PATHS,
} from '~/constants';
import { Breadcrumb, CategoryInterface } from '~/modules/GraphQL/types';

export interface CategoryHelpers {
  getCategoryId: (path: string, pathIndex: number) => number,
  sanitizeMedia: (imageSrc: string) => string,
  getBestsellerTitle: (category: CategoryInterface) => string,
  isPaperPage: (category: CategoryInterface) => boolean,
  getBrandTitle: (category: CategoryInterface) => string,
  checkIsExclusiveLayout: (urlPath: string) => boolean,
  checkIsSwitchSave: (paths: string) => boolean,
  getCategoryNameForGtm: (breadcrumbs: Breadcrumb[]) => string,
}

export const getCategoryId = (path: string, pathIndex: number) => {
  const categoryPath = path.split('/');

  return +categoryPath[pathIndex];
};

export const sanitizeMedia = (imageSrc: string) => (imageSrc !== undefined ? `/${imageSrc.replace(/\/media.*\/(.*)/, '$1')}` : '/');

export const getBestsellerTitle = (category?: CategoryInterface): string => {
  const parentCategoryName = category?.breadcrumbs?.[0]?.category_name || '';

  const name = !parentCategoryName ? category.name.toLowerCase() : category.name;

  return `Bestselling ${name} ${parentCategoryName.toLowerCase()}`;
};

export const isPaperPage = (category?: CategoryInterface): boolean => {
  const pathIds = category?.path?.split('/') || '';

  return pathIds.includes(`${PAPER_CATEGORY_ID}`);
};

export const getBrandTitle = (category?: CategoryInterface): string => {
  if (isPaperPage(category)) {
    return category.name;
  }

  const parentCategoryName = category?.breadcrumbs?.[0]?.category_name || '';

  return `${category.name} ${parentCategoryName.toLowerCase()}`;
};

export const checkIsExclusiveLayout = (urlPath: string): boolean => EXCLUSIVE_LAYOUT_URLS.includes(urlPath);

export const checkIsSwitchSave = (paths: string): boolean => {
  if (!paths?.length) {
    return false;
  }

  return !!SWITCH_AND_SAVE_PATHS.find((path) => paths.includes(`${path}`));
};

export const getCategoryNameForGtm = (breadcrumbs: Breadcrumb[]): string => `${breadcrumbs?.[1]?.category_name || ''} ${breadcrumbs?.[0]?.category_name || ''}`;

const categoryHelpers: CategoryHelpers = {
  getCategoryId,
  sanitizeMedia,
  getBestsellerTitle,
  isPaperPage,
  getBrandTitle,
  checkIsExclusiveLayout,
  checkIsSwitchSave,
  getCategoryNameForGtm,
};

export default categoryHelpers;
